module.exports = __webpack_public_path__ + "img/高级查询.307479a0.svg";